import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { INewsFeedMenuItem } from '@fi-app/news-feed/news-feed';

@Component({
    selector: 'fi-news-feed-item-menu',
    template: `
        <button
          mat-icon-button
          class="menu-item-more-btn"
          [matMenuTriggerFor]="matMenu"
          aria-label="Menu item more button"
          >
          <mat-icon class="icon-dot-3"></mat-icon>
        </button>
        <mat-menu #matMenu="matMenu" xPosition="before" [class]="'fi-news-feed-item-menu-panel'">
          @for (item of menuItems; track item) {
            @if (!item.condition || item.condition()) {
              <button mat-menu-item (click)="item.onClick()">
                @if (item.iconClass) {
                  <span [class]="'menu-item-icon ' + item.iconClass"></span>
                }
                {{ item.title | fiAppText }}
              </button>
            }
          }
        </mat-menu>
        `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./news-feed-item-menu.component.scss'],
    host: { class: 'fi-news-feed-item-menu' },
    standalone: false,
})
export class NewsFeedItemMenuComponent {
    @Input() menuItems: INewsFeedMenuItem[];
}
